import React from "react";
import {Col, Jumbotron, Row} from "reactstrap";
import Question from "../containers/Question";
import Navigation from "../containers/Navigation";

const AnswerValuesInfo = () => (
    <Row>
        <Col className={"m-3 test-body-info"}>
            <small>* Трябва да отговорите на всички въпроси, за да видите резултатите</small>
        </Col>
    </Row>
);

const ResultsInfo = () => (
    <Row>
        <Col className={"mt-3 test-body-info text-center"}>
            <small>Можете да видите резултатите от теста</small>
        </Col>
    </Row>
);

const TestView = ({currentStageTitle, isAllQuestionsAnswered = false}) => (
    <React.Fragment>
        <Row>
            <Col md={{size: 12, offset: 0}}><h3>{currentStageTitle}</h3></Col>
        </Row>
        <Row>
            <Col md={{size: 12}}>
                <Jumbotron>
                    <small>Моля, оценете в каква степен сте преживяли симптома по-долу през изминалата седмица</small>
                </Jumbotron>
            </Col>
        </Row>
        <Question/>
        <Navigation/>
        {isAllQuestionsAnswered ? <ResultsInfo/> : <AnswerValuesInfo/>}
    </React.Fragment>
);

export default TestView